<!--
@Author: Calvin Green <calvin>
@Date:   2021-12-22T11:46:53+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-01-14T14:09:09+02:00
@Copyright: Diversitude 2021
-->



<template>
    <div>
        <b-card no-body>
            <template #header>
                <div class="d-flex">
                    <b-button @click="$emit('back')" size="sm" variant="outline-secondary" class="me-2">
                        <i class="fas fa-arrow-left"></i>
                    </b-button>
                    <strong class="pt-1">
                        Manage Attachments
                    </strong>
                </div>
            </template>
            <div class="p-2">
                <webix-ui v-if="attachments != null" :config="ui" v-model="attachments"></webix-ui>
                <b-button @click="addAttachment" variant="primary" class=" mt-2 me-auto" style="float: right;">Add</b-button>
            </div>
        </b-card>
        <SopModal :sop_type_id="sop_data.id" v-if="show_modal" />
    </div>
</template>

<script>
import {getSpreadifyBackend} from '@/helpers/spreadify.js';
import { sopState, sopMethods } from '@/state/helpers.js'
import Swal from "sweetalert2";
import SopModal from '@/components/documents/modals/addAttachmentModal.vue'

//import _ from 'lodash';
export default {
    data:() => ({
        show_modal: false,
        views: [],
        ui:{
            view: 'datatable',
            css: "datatableApplicants",
            select: 'row',
            hover: 'row-hover',
            autoheight: true,
            fillspace: true,
            drag: "order",
            data:[],
            onClick:{
                //eslint-disable-next-line
                delete_button:function(id, e, trg) {
                    var xs = this.$scope.$parent;
                    Swal.fire({
                        title: "Are you sure you want to delete this attachment?",
                        text: "You won't be able to revert this!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#34c38f",
                        cancelButtonColor: "#f46a6a",
                        confirmButtonText: "Yes, delete it!",
                    }).then((result) => {
                        if (result.value) {
                            xs.deleteSopAttachment({id: e.row}).then(() => {
                                xs.loadSopData(xs.sop_data.id);
                            });
                        }
                    });
                }
            },
            columns:[
                { id: 'attachment_no', header: 'Attachment No', adjust: true },
                { id: 'name', header: 'Name', adjust: true},
                //{ id: 'description', header: 'Description', fillspace: 1},
                {id: 'attachment_type', header: 'Type', fillspace: 1 },
                //eslint-disable-next-line
                { id: 'actions', header: 'Actions', fillspace: 0.6, template(obj, common, value){
                    return  '<span><b-button class="webix_button delete_button">Delete</b-button>&nbsp</span>'
                }}
            ],
        }
    }),
    components:{
        SopModal,
    },
    computed:{
        ...sopState,
        attachments() {
            return this.sop_data.attachments;
        }
    },
    methods:{
        ...sopMethods,
        addAttachment(){
            this.showModal();
        },
        //eslint-disable-next-line
        duplicateAttachment(view_id){
            let params = {
                attachment_id: view_id,
                link_sop_id: this.sop_data.id,
            }
            this.duplicateSopAttachment(params);
        },
        //* misc
        showModal(){
            this.show_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('addSopModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'addSopModal'){
                        this.show_modal = false;
                    }
                })
            })
        }
    },
    mounted(){
        getSpreadifyBackend().getViews()
        .then((response) => {
            this.views = response;
        });
    },
}
</script>

<style>

</style>
